module.exports = __webpack_public_path__ + "static/img/Adult-Human-Torso-A01-X-Ray4.0028c6f6.jpg";